import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/minimal.css";
import "./styles/auth.css";
import "./styles/wishlist.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
